// extracted by mini-css-extract-plugin
export default {"info__container":"IngredientDetails_info__container__BF1fx","info__name":"IngredientDetails_info__name__bo3RY","info__article":"IngredientDetails_info__article__XVtYz"};